import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./footer.css";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import EmailIcon from "@mui/icons-material/Email";
function Footer() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  });
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content" data-aos="fade-up">
            <ul className="footer-content__1">
              <li>
                <span>CAR</span> Rental
              </li>
              <li>
                Discover a wide range of vehicles tailored to meet all your
                driving needs. Your perfect ride awaits with us!
              </li>
              <li>
                <a href="tel:123456789">
                  <PhoneInTalkIcon />
                  &nbsp; +40 74655555
                </a>
              </li>

              <li>
                <a
                  href="mailto: 
                  carrental@gmail.com"
                >
                  <EmailIcon />
                  &nbsp; rentacar@gmail.com
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Company</li>
              <li>
                <a href="#home">Bucharest</a>
              </li>
              <li>
                <a href="#home">Careers</a>
              </li>
              <li>
                <a href="#home">Mobile</a>
              </li>
              <li>
                <a href="#home">Blog</a>
              </li>
              <li>
                <a href="#home">How we work</a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Working Hours</li>
              <li>Mon - Fri: 9:00AM - 9:00PM</li>
              <li>Sat: 9:00AM - 19:00PM</li>
              <li>Sun: Closed</li>
            </ul>

            <ul className="footer-content__2">
              <li>Subscription</li>
              <li>
                <p>Subscribe your Email address for latest news & updates.</p>
              </li>
              <li>
                <input type="email" placeholder="Enter Email Address"></input>
              </li>
              <li>
                <button className="submit-email">Submit</button>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
